Ext.ns('mx.comp');

mx.comp.StateSelectCombo = Ext.extend(mx.comp.LinkedComboBox, {
    editable: true, // We have only US states predefined,
    forceSelection: false, // so user must be able to enter plain text

    labels: {
        fieldLabel: 'State/Province',
        emptyText: 'Select a state/province...',
        blankText: 'State/Province is a required field',
    },

    fieldLabel: null,
    emptyText: null,
    blankText: null,

    valueField: 'id',
    displayField: 'name',

    url: null,

    initComponent: function() {
        this.fieldLabel = this.labels.fieldLabel;
        this.emptyText = this.labels.emptyText;
        this.blankText = this.labels.blankText;

        this.store = mx.data.State.newStore({url: this.url});
        mx.comp.StateSelectCombo.superclass.initComponent.call(this);
    },
});

Ext.reg('mx-statecombo', mx.comp.StateSelectCombo);
